/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svd_Work_Case_Study_NoteInputs */

const en_svd_work_case_study_note = /** @type {(inputs: Svd_Work_Case_Study_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`linked to live /work routes`)
};

const ar_svd_work_case_study_note = /** @type {(inputs: Svd_Work_Case_Study_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مرتبط بمسارات /work المباشرة`)
};

const bn_svd_work_case_study_note = /** @type {(inputs: Svd_Work_Case_Study_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`লাইভ /work রাউটের সাথে লিংকড`)
};

const de_svd_work_case_study_note = /** @type {(inputs: Svd_Work_Case_Study_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`verknüpft mit Live-/Arbeitsrouten`)
};

const es_svd_work_case_study_note = /** @type {(inputs: Svd_Work_Case_Study_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vinculado a rutas de vida/trabajo`)
};

const fr_svd_work_case_study_note = /** @type {(inputs: Svd_Work_Case_Study_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`lié aux itinéraires en direct/travail`)
};

const pt_svd_work_case_study_note = /** @type {(inputs: Svd_Work_Case_Study_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`vinculado a rotas em tempo real/de trabalho`)
};

const zh_svd_work_case_study_note = /** @type {(inputs: Svd_Work_Case_Study_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`链接到生活/工作路线`)
};

const tr_svd_work_case_study_note = /** @type {(inputs: Svd_Work_Case_Study_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`canlı/iş yollarına bağlı`)
};

const ru_svd_work_case_study_note = /** @type {(inputs: Svd_Work_Case_Study_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`связан с живыми/рабочими маршрутами`)
};

const pl_svd_work_case_study_note = /** @type {(inputs: Svd_Work_Case_Study_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`powiązany z trasami na żywo/pracą`)
};

/**
* | output |
* | --- |
* | "linked to live /work routes" |
*
* @param {Svd_Work_Case_Study_NoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svd_work_case_study_note = /** @type {((inputs?: Svd_Work_Case_Study_NoteInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svd_Work_Case_Study_NoteInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svd_work_case_study_note(inputs)
	if (locale === "bn") return bn_svd_work_case_study_note(inputs)
	if (locale === "de") return de_svd_work_case_study_note(inputs)
	if (locale === "es") return es_svd_work_case_study_note(inputs)
	if (locale === "fr") return fr_svd_work_case_study_note(inputs)
	if (locale === "pt") return pt_svd_work_case_study_note(inputs)
	if (locale === "zh") return zh_svd_work_case_study_note(inputs)
	if (locale === "tr") return tr_svd_work_case_study_note(inputs)
	if (locale === "ru") return ru_svd_work_case_study_note(inputs)
	if (locale === "pl") return pl_svd_work_case_study_note(inputs)
	return en_svd_work_case_study_note(inputs)
});